const config =  {
  labels: {
    appTitle: "Choir Player",
    library: "Song Library",
    setlist: "My Setlist",
    setlists: "Your Setlists",
    settings: "Settings"
  },
  images: {
    menuLogo: "/images/choir-player/choirplayer-logo.svg",
	menuLogoLink: "https://www.choirplayer.com",
    menuBackground: "/images/choir-player/brave_bg1.jpg",
    loginLogo: "/images/choir-player/choirplayer-logo-pink.svg",
    loginSplash: "/images/choir-player/login-splash.jpeg",
    registrationPromo: "/images/choir-player/login-splash.jpeg",
    defaultSetlistImage: "/images/3fire/defaultPlaylist.jpeg",
    albumArt: "/images/choir-player/album-art.png"
  },
  features: {
    audio: {
      record: true,
      downloadMix: true,
      shareMix: true,
    },

    help: {
      markdownPath: '/help/index.md'
    },

    setlist: {
      enabled: false,
      renameSession: false,
      downloadSetlist: false,
      showHeader: true,
      urlShortenerUrl: "https://www.choirplayer.com/wp-json/v1/shorten/",
      defaultSetlistImageUrl:"https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/9758650"
    },
    setlists: {
      enabled: true,
    },
    session: {
      showMixRecord: false,
      showMixDownload: false,
      showMixShare: false,
      showMixReset: true,
      showMixControls: false,
      mixerTemplate: 'choir',
      loadingAnimationFile: 'notes',
      showCueControls: false,
      showLyrics: true,
      initialStemLevel: 1,
      introChannelNames: [],
      click1ChannelNames: [],
      click2ChannelNames: [],
      cueChannelNames: [],
      cacheOnMount: false
    },
    library: {
      alwaysAddSongToMyPlaylist: false,
	  endpoint:"https://sessionplayer.s3.amazonaws.com/song_list_choirplayer_new_format_with_embedded_lyrics_and_sheeturl.json",
      limitedLibrary: [
        "com.3firemusic.choirplayer.000090",
        "com.3firemusic.choirplayer.000110",
        "com.3firemusic.choirplayer.000024"
      ],
      subscribeConfig: {
        libraryTitle: "Click on one of these songs to play it for free !",
        libraryText: "",
        libraryPromoText: "Click on the button below to subscribe to the full Choir Player",
        libraryPromoButtonText: "Subscribe",
        text: "You are not currently subscribed to ChoirPlayer, so this song is unavailable. Try one of the free songs, or ...",
        playlistCreationDeniedText: "You are not currently subscribed to ChoirPlayer, so you cannot create a playlist.",
        buttonLabel: "Subscribe to ChoirPlayer now!",
        url: "https://www.choirplayer.com/product/monthly-subscription/"
      },
      songsToHide: [],
      songsWorkingOnIos: []
    },
    analytics: {
      token: "G-QGDSN1N3G8"
    },
    auth: {
      mode: 'domainCookie',
      domainCookie: {
        cookieId: 'session_id',
        loginUrl: '',
        dashboardUrl: "https://www.choirplayer.com/my-account/",
        userInfoUrl: "https://choirplayer.com/wp-json/v1/user/",
        logoutUrl: "",
        loginLabel: "",
        logoutLabel: "",
        loggedOutState: {
          user: {
            ID: "domainCookie-guest",
            displayName: "Guest User",
            subscribed: false,
            guest: true
          },
          status: 'fulfilled',
          errorMessage: null
        },
        loggedInState: {
          user: null,
          status: 'fulfilled',
          errorMessage: null
        }
      }
    },
    notifications: {
      timeout: 4000
    }
  },
  theme: {
    darkMode: false,
    colours: {
      primary: '#c4327a',
      primaryAlt: '#515151'
    }
  },
  logic: {
    trimStemTitles: true,
    applyExtraLogicToStemTitles: true,
    deniedBrowsers: [],
    restrictedDevices: ["iPhone", "iPad"]
  },
  aws: {
    credentials: {
      accessKeyId: "AKIA4HS77K2RWAD37CNZ",
      secretAccessKey: "FqVAvWTuJaXcJAQIQlx7m\+\+Y7ZC\/6XAU9HACAw\/k",
      region: "eu-west-1"
    },
    s3: {
      bucketName:"uploads.choirplayer.com",
    }
  }
};

export default config;
